import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

import useDecryption from '../../../../../hooks/cryptography/decryptText';
import DecryptionLoadingAnimation from '../../../../common/decryptionLoadingAnimation';

interface ReportInfoDetailsProps {
  description: string;
  redactedPositions: [number, number][];
}

const ReportInfoDetails = ({
  description,
  redactedPositions,
}: ReportInfoDetailsProps) => {
  const [decryptedText, setDecryptedText] = useState<string | null>(null);
  const [decryptStatus, setDecryptStatus] = useState(true);
  const { decryptText } = useDecryption();

  useEffect(() => {
    const getText = async () => {
      const descriptionText = await decryptText(description);
      if (descriptionText === null) {
        setDecryptStatus(false);
        return;
      }
      setDecryptStatus(false);
      setDecryptedText(descriptionText);
    };

    getText();
  }, [description, decryptText]);

  const HighlightedRedactedDescription = () => {
    if (!decryptedText) {
      return <></>;
    }
    const applyHighlight = () => {
      let redactedText = '';
      let lastIndex = 0;

      // Sort ranges based on start index
      if (redactedPositions) {
        redactedPositions.sort((a, b) => a[0] - b[0]);

        redactedPositions.forEach((range) => {
          const [start, end] = range; // Subtract 11 from each value

          // Append non-highlighted text
          redactedText += decryptedText.substring(lastIndex, start);

          // Append highlighted text
          redactedText += `<span style="background-color: yellow">${decryptedText.substring(
            start,
            end,
          )}</span>`;

          lastIndex = end;
        });

        // Append any remaining non-highlighted text
        redactedText += decryptedText.substring(lastIndex);

        return { __html: redactedText };
      }
      return { __html: decryptedText };
    };
    return (
      <div
        className='formatted-text-viewer'
        style={{ wordWrap: 'break-word', padding: '0px', height: 'inherit' }}
        dangerouslySetInnerHTML={applyHighlight()}
      />
    );
  };

  return (
    <>
      {decryptStatus ? (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <DecryptionLoadingAnimation />
        </Box>
      ) : (
        <HighlightedRedactedDescription />
      )}
    </>
  );
};

export default ReportInfoDetails;
